/*
 * Copyright (c) 2025. Sergey S. Chernov - All Rights Reserved
 *
 *  You may use, distribute and modify this code under the
 * terms of the private license, which you must obtain from the author
 *
 * To obtain the license, contact the author: https://t.me/real_sergeych or email to
 * real dot sergeych at gmail.
 */

package net.sergeych.kiloparsec

import kotlinx.serialization.Serializable
import net.sergeych.crypto2.SafeKeyExchange
import net.sergeych.crypto2.Seal
import net.sergeych.crypto2.VerifyingPublicKey

// L0 commands - key exchange and check:
@Serializable
data class Handshake(val version: UInt, val publicKey: SafeKeyExchange.PublicKey,
                     val signature: Seal? = null)

@Serializable
data class ClientIdentity(val clientIdKey: VerifyingPublicKey?, val signature: UByteArray?)

// Level 0 command: request key exchange
internal val L0Request by command<Handshake, Handshake>()
internal val L0ClientId by command<UByteArray, Unit>()
internal val L0Call by command<UByteArray,UByteArray>()
